import React, { useState, useEffect } from "react";
import "./../../css/attendeeMapping.css";
import SearchedAttendeeList from "./SearchedAttendeeList";
import MappedCABAttendeeList from "./MappedCABAttendeeList";
import MappedEncoraAttendeeList from "./MappedEncoraAttendeeList";
import { Button } from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { getPassCode} from "../../utils";

import { formatDate } from "../../common";

const AttendeeMapping = ({ showLoading }) => {
  const [searchedValue, setSearchedValue] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isRemoveAttendee, setisRemoveAttendee] = useState(false);
  const [user, setUser] = useState({
    eventTitle: "",
    eventType: "",
    eventStartDate: "",
    eventEndDate: "",
    eventId: "",
  });
  const [isAddAttendee, setIsAddAttendee] = useState(false);

  useEffect(() => {
    if(getPassCode() === ""){
      navigate("/login");
    }
    showLoading(true);
    setUser(location.state.event);
    showLoading(false);
  }, [location.state.event, showLoading, navigate]);

  const handleSearch = (value = "") => {
    setSearchedValue(value);
    setIsSubmitted(true);
  };

  const handleClose = () => {
    navigate("/event-management", { state: {} });
  };

  return (
    <>
      <div className="manage-user-events attendeeMapping w3-container mt-4">
        <p className="roboto-bold mb-2 color-black t-h">Attendee Mapping</p>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb fs-0-8">
            <li className="breadcrumb-item">
              <Link className="color-purple" to="/dashboard">
                Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              <Link className="color-purple" to="/event-management">
                Manage Event
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Attendee Mapping
            </li>
          </ol>
        </nav>

        {user.eventId && (
          <>
            <div className="row middle-panel">
              <div className="col-md-12 col-sm-12">
                <div className="card mb-4">
                  <div className="card-body p-4">
                    <p className="fw-500 m-0 s-h mb-3"> Event Details </p>
                    <div className="d-flex justify-content-between">
                      {
                        <ul className="color-purple events fw-500 d-flex justify-content-between">
                          <li>
                            <span className="color-gray fw-normal">
                              Event Name:
                            </span>{" "}
                            <span>{user.eventTitle}</span>
                          </li>
                          <li className="d-line color-gray">|</li>
                          <li>
                            <span className="color-gray fw-normal">
                              Event Type:
                            </span>{" "}
                            <span>{user.eventType}</span>
                          </li>
                          <li className="d-line color-gray">|</li>
                          <li>
                            <span className="color-gray fw-normal">
                              Start Date:
                            </span>{" "}
                            <span>{formatDate(user.eventStartDate)}</span>
                          </li>
                          <li className="d-line color-gray">|</li>
                          <li>
                            <span className="color-gray fw-normal">
                              End Date:
                            </span>{" "}
                            <span>{formatDate(user.eventEndDate)}</span>
                          </li>
                        </ul>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="middle-panel card mt-2">
              <div className="card-body p-0 p-sm-4">
                <div className="p-4 pb-0 p-sm-0">
                  <p className="mapAttendees fw-500 m-0 s-h mb-4">
                    {" "}
                    Map Attendees{" "}
                  </p>

                  <div className="search col-md-6 mb-3">
                    <span className="color-gray fw-normal">
                      {" "}
                      Search Attendee Name:{" "}
                    </span>
                    <span className="fa-search">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-search"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Search..."
                      id="myInput"
                      value={searchedValue || ""}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Searched Attendee Table List */}
                <SearchedAttendeeList
                  isSubmitted={isSubmitted}
                  searchedValue={searchedValue}
                  setIsSubmitted={setIsSubmitted}
                  eventId={user.eventId || ""}
                  setIsAddAttendee={setIsAddAttendee}
                  showLoading={showLoading}
                  setSearchedValue={setSearchedValue}
                  isRemoveAttendee={isRemoveAttendee}
                  setisRemoveAttendee={setisRemoveAttendee}
                />

                {/* Mapped CAB Attendee Table List */}
                <MappedCABAttendeeList
                  eventId={user.eventId || ""}
                  isAddAttendee={isAddAttendee}
                  setIsAddAttendee={setIsAddAttendee}
                  showLoading={showLoading}
                  setisRemoveAttendee={setisRemoveAttendee}
                />

                {/* Mapped Encora Attendee List */}
                <MappedEncoraAttendeeList
                  eventId={user.eventId || ""}
                  isAddAttendee={isAddAttendee}
                  setIsAddAttendee={setIsAddAttendee}
                  showLoading={showLoading}
                  setisRemoveAttendee={setisRemoveAttendee}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <br />
      <div className="attendeeMapping w3-container mt-2 mb-4">
        <Button
          variant="purple"
          onClick={() => handleClose()}
          className="btn btn-purple btn-sm btn-view-event ps-4 pe-4"
        >
          Close
        </Button>
      </div>
      <br />
    </>
  );
};

export default AttendeeMapping;
